/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Authenticator } from "aws-amplify-react";
import { Auth } from "aws-amplify";
import config from "./aws-exports";
// Redux store
import store from "./store";
import { Provider } from "react-redux";
import { Spinner, Container } from "react-bootstrap";

// Components
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import CacheBuster from "./Components/CacheBuster";
import Routes from "./Components/routing/Routes";
import BusinessBar from "./Components/BusinessBar";
import MenuUploadModal from "./Components/MenuUpload";
import CustomSignIn from "./Components/CustomSignIn";
import CustomGreetings from "./Components/CustomGreetings";
import CustomSignUp from "./Components/CustomSignUp";
import CustomResetPassword from "./Components/CustomResetPassword";
import CustomForgotPassword from "./Components/CustomForgotPassword";
import CustomConfirmAccount from "./Components/CustomConfirmAccount";
import CustomNewPasswordRequired from "./Components/CustomNewPasswordRequired";
import Onboarding from "./Components/Onboarding";
import ListPlans from "./Components/Onboarding/ListPlans";

// Actions
import { getAuthUserData } from "./actions/Auth";
import { getListPlans } from "./actions/Plan";
import Header from "./Components/Onboarding/Header";

export const AppUnAuthorized = ({ updateAuthState }) => {
  const [accountProcessing, setAccountProcessing] = useState({ email: "" });
  const [isNewPassword, setStateNewPassword] = useState(false);

  return (
    <div className="auth-section">
      <div
        className={
          isNewPassword ? "auth-new-password-container" : "auth-container"
        }
      >
        <Authenticator
          amplifyConfig={config}
          onStateChange={(authState, account) => {
            // Log current authState
            if (authState === "signedIn") {
              updateAuthState(authState);
            }

            // Set account when "reset password" or "confirm the account"
            if (account) {
              setAccountProcessing(account);
            }

            // Update style auth container if set up new password
            setStateNewPassword(authState === "newPasswordRequired");
          }}
          hideDefault
          authState="signIn"
        >
          <CustomGreetings />
          <CustomSignIn />
          <CustomSignUp />
          <CustomForgotPassword />
          <CustomResetPassword account={accountProcessing} />
          <CustomConfirmAccount account={accountProcessing} />
          <CustomNewPasswordRequired account={accountProcessing} />
        </Authenticator>
      </div>
    </div>
  );
};

export const AppAuthenticated = () => {
  useEffect(() => {
    // Get data of login user
    store.dispatch(getAuthUserData());
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <BusinessBar />
        <MenuUploadModal />
        <Routes />
      </Router>
    </Provider>
  );
};

export const AppPricingPage = () => {
  useEffect(() => {
    // Get list plans
    store.dispatch(getListPlans());
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Header />
        <Container className="onboarding min-vh-100" fluid>
          <Switch>
            <Route exact path="/onboarding" component={Onboarding} />
            <Route exact path="/plans" component={ListPlans} />
          </Switch>
        </Container>
      </Router>
    </Provider>
  );
};

export const AppFresh = () => {
  // Set the page initial state is processing
  const [authState, setAuthState] = useState("processing");

  const isOnboardingPage = !!window.location.pathname.match(
    /plans|onboarding/gi
  );

  useEffect(() => {
    const loadAuthState = async () => {
      try {
        // Not need to check auth if is the onboarding page
        if (isOnboardingPage) {
          setAuthState("pricing");
        } else {
          // Get state of signed in user
          await Auth.currentAuthenticatedUser();
          setAuthState("authenticated");
        }
      } catch (err) {
        // Throw error if user have not signed in yet
        setAuthState("unauthorized");
      }
    };

    loadAuthState();
  }, []);

  const handleUpdateAuthState = (authState) => {
    if (authState === "signedIn") {
      setAuthState("authenticated");
    }
  };

  // Render the App component base on the authState
  switch (authState) {
    case "unauthorized":
      return <AppUnAuthorized updateAuthState={handleUpdateAuthState} />;

    case "authenticated":
      return <AppAuthenticated />;

    case "pricing":
      return <AppPricingPage />;

    case "processing":
      return (
        <div className="auth-section">
          <div className="auth-container">
            <CustomGreetings />
            <Spinner
              as="span"
              animation="border"
              size="lg"
              role="isProcessing"
              aria-hidden="true"
            />
          </div>
        </div>
      );

    default:
      return null;
  }
};

const AppCacheBuster = () => (
  <CacheBuster>
    {({ loading, isLatestVersion, refreshCacheAndReload }) => {
      if (loading) return null;
      if (!loading && !isLatestVersion) refreshCacheAndReload();
      return <AppFresh />;
    }}
  </CacheBuster>
);

export default AppCacheBuster;
